import { useCallback } from 'react';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';
import useNextSo5FixtureTeamSlugs from '@sorare/core/src/hooks/config/useNextSo5FixtureTeamSlugs';
import { useFormatGameWeekLabel } from '@sorare/core/src/hooks/useFormatGameWeekLabel';

export const useFormatActiveFixtureLabel = () => {
  const formatGameWeekLabel = useFormatGameWeekLabel();
  const teamsPlayingNextDailyFixture = useNextSo5FixtureTeamSlugs(
    So5FixtureEvent.DAILY
  );
  const teamsPlayingNextWeeklyFixture = useNextSo5FixtureTeamSlugs(
    So5FixtureEvent.CLASSIC
  );

  return useCallback(
    (slug: string | false, type: So5FixtureEvent) => {
      const selectedFixture = (
        type === So5FixtureEvent.DAILY
          ? teamsPlayingNextDailyFixture
          : teamsPlayingNextWeeklyFixture
      ).find(f => f.slug === slug);

      if (selectedFixture) {
        return formatGameWeekLabel({
          ...selectedFixture,
          type,
        });
      }
      return '';
    },
    [
      formatGameWeekLabel,
      teamsPlayingNextDailyFixture,
      teamsPlayingNextWeeklyFixture,
    ]
  );
};
